import { safetyTips } from "@/mocks/home";

export default function SafetyTips() {
  return (
    <section id="safety" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-10 items-start">
          <div className="lg:col-span-2">
            <span className="text-xs md:text-sm font-label tracking-widest text-primary-600 uppercase">
              Safety Tips
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">
              访问时的安全提示
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              找地址、换域名本身不难，难的是在过程中保持判断力。
              下面几条不涉及任何复杂操作，但能显著降低遇到仿冒页面、恶意弹窗和诱导下载的概率。
            </p>
            <div className="mt-6 p-4 rounded-lg bg-accent-50 border border-accent-200">
              <p className="text-xs md:text-sm leading-relaxed text-accent-900">
                <span className="font-medium">一句话原则：</span>
                凡是来源说不清、一进去就催你下载或填信息的页面，一律先退出，再回到官方公告重新核对。
              </p>
            </div>
          </div>

          <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {safetyTips.map((tip) => (
              <article
                key={tip.title}
                className="p-5 rounded-lg bg-background-100 border border-background-200/70"
              >
                <span className="w-10 h-10 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                  <i className={`${tip.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 font-heading text-base text-foreground-950">{tip.title}</h3>
                <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600">
                  {tip.desc}
                </p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}